import { useEffect, useState } from 'react';
import Pusher from 'pusher-js';
import { useAppSelector } from 'hooks';
import { selectIsLiveChatMode } from 'reducers/workflows';
import { selectLiveChatIntegration } from 'reducers/live-chat';
import { isPusherLiveChatIntegration } from 'api/types';

// Global Pusher instance shared across the application
let globalPusher: Pusher | null = null;

/**
 * Gets or creates the global Pusher instance
 */
export const getOrCreatePusher = (): Pusher => {
  if (!globalPusher) {
    const PUSHER_KEY =
      process.env.REACT_APP_PUSHER_KEY || '7d93496a6cb894633b32';
    const PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER || 'us3';
    globalPusher = new Pusher(PUSHER_KEY, {
      cluster: PUSHER_CLUSTER,
    });
  }
  return globalPusher;
};

/**
 * Initializes Pusher
 *
 * [connection definition](https://pusher.com/channels/pricing/#:~:text=How%20do%20you%20define%20connections%3F)
 *
 * [new Pusher(...)](https://pusher.com/docs/channels/using_channels/connection/#connecting-to-channels) increases the connection count
 */
export const useInitPusher = () => {
  const [pusher, setPusher] = useState<Pusher | undefined>(
    globalPusher || undefined,
  );
  const isLiveChatMode = useAppSelector(selectIsLiveChatMode);
  const liveChatIntegration = useAppSelector(selectLiveChatIntegration);

  useEffect(() => {
    if (
      isLiveChatMode &&
      isPusherLiveChatIntegration(liveChatIntegration) &&
      !pusher
    ) {
      const instance = getOrCreatePusher();
      setPusher(instance);
    }
  }, [isLiveChatMode, liveChatIntegration, pusher]);

  return pusher;
};
